var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessZoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L11.6167 11.6167M7.22209 4.8888V9.55537M4.8888 7.22209H9.55537M13.4442 7.22209C13.4442 10.6585 10.6585 13.4442 7.22209 13.4442C3.78572 13.4442 1 10.6585 1 7.22209C1 3.78572 3.78572 1 7.22209 1C10.6585 1 13.4442 3.78572 13.4442 7.22209Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessZoom);
export default __webpack_public_path__ + "static/media/process-zoom.a0756fb029408121080cb18d45ff0f32.svg";
export { ForwardRef as ReactComponent };